export const environment = {
  production: false,
  apiBaseUrl: '/api',

  /**
   * Default version / effective date when the API document does not set them yet.
   * After Save in Edit Terms, those values live in the stored front matter.
   */
  terms: {
    version: '1.1',
    effectiveDate: '16 September 2026',
    effectiveIso: '2026-09-16'
  },

  /** Contracting entity and public contact — footer, Terms, billing. */
  provider: {
    legalName: 'Irish Taylor & Co Pty Ltd',
    shortName: 'Irish Taylor',
    abn: '67 650 161 578',
    address: 'Level 1, 63-73 Ann Street, Surry Hills NSW 2010, Australia',
    contactEmail: 'onedesk@irishtaylor.com'
  }
};
